import { useQuery } from '@tanstack/react-query';
import { fetchListaEventosSimples, type ListaEventosFiltro } from '../api/ListaEventosSimplesApi';

export function useListaEventosSimples(filtro: ListaEventosFiltro, enabled: boolean) {
  return useQuery({
    queryKey: ['lista-eventos-simples', filtro],
    queryFn: () => fetchListaEventosSimples(filtro),
    enabled,
    staleTime: 60_000,
  });
}
